module.exports = __webpack_public_path__ + "static/media/next.0aac1dcc.svg";